// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"38e11c16","355":"7022959a","581":"a1297011"}[chunkId] + ".chunk.js";
};